import "./Results.module.css";
import ProductionHeader from "@/reusable_sections/Header";
import TransformYourSpace from "./sections/TransformYourSpace";
import HarvestSeasonTimeline from "./sections/HarvestSeasonTimeline";
import LegacyVsModern from "./sections/LegacyVsModern";
import PiedDePage from "@/reusable_sections/Footer";
export default function ResultsPage() {
  return <div>
      <ProductionHeader />
      <TransformYourSpace />
      <HarvestSeasonTimeline />
      <LegacyVsModern />
      <PiedDePage />
    </div>;
}